(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-page"]) return;
  try {
    
  (function () {
    function getSectionId() {
      var root = document.querySelector('[data-cart-page]');
      return root && root.getAttribute('data-section-id');
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      return (cents / 100).toFixed(0) + ' zł';
    }

    function updateHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        if (count < 1) {
          el.setAttribute('hidden', '');
        } else {
          el.removeAttribute('hidden');
        }
      });
    }

    function refreshCartPage() {
      var sectionId = getSectionId();
      if (!sectionId) {
        window.location.reload();
        return;
      }

      var url =
        ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') +
        '?section_id=' +
        encodeURIComponent(sectionId);

      return fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-cart-page]');
          var current = document.querySelector('[data-cart-page]');
          if (next && current && current.parentNode) {
            current.parentNode.replaceChild(next, current);
            bindCartPage(next);
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          window.location.reload();
        });
    }

    function removeLine(key) {
      var changeUrl =
        ((window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_change_url) ||
          '/cart/change') + '.js';

      return fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          return refreshCartPage();
        });
    }

    function bindCartPage(root) {
      if (!root || root.dataset.cartPageBound === 'true') return;
      root.dataset.cartPageBound = 'true';

      root.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var key = btn.getAttribute('data-line-key');
          if (!key) return;
          btn.disabled = true;
          removeLine(key).finally(function () {
            btn.disabled = false;
          });
        });
      });

      var discountToggle = root.querySelector('[data-cart-discount-toggle]');
      var discountField = root.querySelector('[data-cart-discount-field]');
      if (discountToggle && discountField) {
        discountToggle.addEventListener('click', function () {
          var open = discountField.hasAttribute('hidden');
          if (open) {
            discountField.removeAttribute('hidden');
            discountToggle.setAttribute('aria-expanded', 'true');
            var input = discountField.querySelector('input');
            if (input) input.focus();
          } else {
            discountField.setAttribute('hidden', '');
            discountToggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }

    bindCartPage(document.querySelector('[data-cart-page]'));

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('[data-cart-page]')) {
        bindCartPage(event.target.querySelector('[data-cart-page]'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DESKTOP_QUERY = '(min-width: 990px)';
    var THRESHOLD = 110;
    var RESISTANCE = 0.42;
    var SCROLL_DURATION = 700;
    var DECAY_MS = 200;
    var RELEASED_KEY = 'lk_landing_snap_released';

    var heroRoot = document.querySelector('[data-landing-scroll-snap]');
    var shopTarget = document.getElementById('landing-shop');

    if (!heroRoot || !shopTarget) {
      return;
    }

    var desktopMq = window.matchMedia(DESKTOP_QUERY);
    var accumulated = 0;
    var decayTimer = null;
    var isAnimating = false;
    var snapReleased = false;

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function isEnabled() {
      return desktopMq.matches && !prefersReducedMotion() && !snapReleased;
    }

    function easeInOutSine(t) {
      return -(Math.cos(Math.PI * t) - 1) / 2;
    }

    function shopScrollTop() {
      return shopTarget.getBoundingClientRect().top + window.scrollY;
    }

    function markSnapReleased() {
      snapReleased = true;
      resetAccumulation();

      try {
        sessionStorage.setItem(RELEASED_KEY, '1');
      } catch (error) {}
    }

    function restoreSnapReleasedState() {
      if (window.location.hash === '#landing-shop') {
        markSnapReleased();
        return;
      }

      try {
        if (sessionStorage.getItem(RELEASED_KEY) === '1') {
          snapReleased = true;
        }
      } catch (error) {}
    }

    function scrollToY(targetY, duration, onComplete) {
      isAnimating = true;
      var startY = window.scrollY;
      var distance = targetY - startY;
      var startTime = performance.now();

      function step(now) {
        var progress = Math.min((now - startTime) / duration, 1);
        window.scrollTo(0, startY + distance * easeInOutSine(progress));

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          isAnimating = false;
          resetAccumulation();
          if (onComplete) {
            onComplete();
          }
        }
      }

      requestAnimationFrame(step);
    }

    function scrollToShop() {
      scrollToY(shopScrollTop(), SCROLL_DURATION, function () {
        markSnapReleased();

        if (window.location.hash !== '#landing-shop') {
          history.replaceState(null, '', '#landing-shop');
        }
      });
    }

    function resetAccumulation() {
      accumulated = 0;
      clearTimeout(decayTimer);
      decayTimer = null;
    }

    function scheduleDecay() {
      clearTimeout(decayTimer);
      decayTimer = window.setTimeout(resetAccumulation, DECAY_MS);
    }

    function isInHeroZone() {
      return shopTarget.getBoundingClientRect().top > window.innerHeight * 0.2;
    }

    function onWheel(event) {
      if (!isEnabled()) {
        return;
      }

      if (isAnimating) {
        event.preventDefault();
        return;
      }

      var delta = event.deltaY;
      if (Math.abs(delta) < 1) {
        return;
      }

      if (delta > 0 && isInHeroZone()) {
        event.preventDefault();
        accumulated += delta * RESISTANCE;
        scheduleDecay();

        if (accumulated >= THRESHOLD) {
          clearTimeout(decayTimer);
          scrollToShop();
        }

        return;
      }

      if (isInHeroZone()) {
        accumulated = Math.max(0, accumulated - Math.abs(delta) * 0.3);

        if (accumulated <= 0) {
          resetAccumulation();
        } else {
          scheduleDecay();
        }
      }
    }

    function onScrollReleaseCheck() {
      if (snapReleased || isAnimating) {
        return;
      }

      if (window.scrollY >= shopScrollTop() - 24) {
        markSnapReleased();
      }
    }

    restoreSnapReleasedState();
    onScrollReleaseCheck();

    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('scroll', onScrollReleaseCheck, { passive: true });

    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', resetAccumulation);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(resetAccumulation);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["your-project-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindProjectForm(root) {
      if (!root || root.dataset.projectFormBound === 'true') return;
      root.dataset.projectFormBound = 'true';

      var form = root.querySelector('form.project-page__form');
      if (!form) return;

      var photoTrigger = root.querySelector('[data-project-photo-trigger]');
      var photoInput = root.querySelector('[data-project-photo-input]');
      var photoPreview = root.querySelector('[data-project-photo-preview]');
      var photoPreviewImg = root.querySelector('[data-project-photo-preview-img]');
      var photoRemove = root.querySelector('[data-project-photo-remove]');
      var ideaField = root.querySelector('[name="contact[body]"]');

      if (photoTrigger && photoInput) {
        photoTrigger.addEventListener('click', function () {
          photoInput.click();
        });
      }

      if (photoInput) {
        photoInput.addEventListener('change', function () {
          var file = photoInput.files && photoInput.files[0];
          if (!file || !photoPreview || !photoPreviewImg) return;

          if (!file.type.startsWith('image/')) {
            photoInput.value = '';
            return;
          }

          var reader = new FileReader();
          reader.onload = function (event) {
            photoPreviewImg.src = event.target.result;
            photoPreviewImg.alt = file.name;
            photoPreview.removeAttribute('hidden');
          };
          reader.readAsDataURL(file);
        });
      }

      if (photoRemove && photoInput && photoPreview) {
        photoRemove.addEventListener('click', function () {
          photoInput.value = '';
          photoPreview.setAttribute('hidden', '');
          if (photoPreviewImg) {
            photoPreviewImg.removeAttribute('src');
            photoPreviewImg.alt = '';
          }
        });
      }

      form.addEventListener('submit', function () {
        if (!ideaField || !photoInput || !photoInput.files || !photoInput.files[0]) return;

        var file = photoInput.files[0];
        var note =
          '\n\n---\n' +
          'Załącznik: ' +
          file.name +
          ' (' +
          Math.round(file.size / 1024) +
          ' KB)\n';

        if (ideaField.value.indexOf('Załącznik:') === -1) {
          ideaField.value = ideaField.value.trim() + note;
        }
      });
    }

    document.querySelectorAll('.project-page__form-wrap').forEach(bindProjectForm);

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('.project-page__form-wrap').forEach(bindProjectForm);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
